import { connect, ConnectedProps } from "react-redux";
import { SelectedPackagePricingCard } from "./component";
import {
  getHotelShopSelectedLodging,
  selectedPackageByRateId,
} from "../../../../hotel-shop/reducer";
import { IStoreState } from "../../../../../reducers/types";
import {
  getPackageNightCountBasedOnAvailability,
  getTravelersCount,
} from "../../../../availability/reducer";
import { getSelectedAccountReferenceIdIfRedemptionEnabled } from "../../../../rewards/reducer";
import {
  getPackageNightCountBasedOnOutboundFlight,
  getSelectedPackageByOutboundFlight,
} from "../../../reducer";

const mapStateToProps = (state: IStoreState) => {
  return {
    selectedLodging: getHotelShopSelectedLodging(state),
    selectedPackageByLodging: selectedPackageByRateId(state),
    rewardsKey:
      getSelectedAccountReferenceIdIfRedemptionEnabled(state) || undefined,
    packageNightCountBasedOnAvailability:
      getPackageNightCountBasedOnAvailability(state),
    packageNightCountBasedOnOutboundFlight:
      getPackageNightCountBasedOnOutboundFlight(state),
    travelersCount: getTravelersCount(state),
    selectedPackageByOutboundFlight: getSelectedPackageByOutboundFlight(state),
  };
};

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type SelectedPackagePricingCardConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedSelectedPackagePricingCard = connector(
  SelectedPackagePricingCard,
);
